import gql from 'graphql-tag';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Alert, Link } from '@zapier/design-system';
export const shouldRender = (data) => {
    const { currentUser, currentAccount } = data;
    return (!currentUser.hasSeenNotifications.jobsCta &&
        !currentAccount.isCompanyAccount);
};
export const setHasSeenJobsCtaMutation = gql `
  mutation setHasSeenJobsCta($profileId: ID!, $hasSeenCta: Boolean!) {
    setHasSeenJobsCta(id: $profileId, hasSeenCta: $hasSeenCta) {
      id
      hasSeenNotifications {
        jobsCta
      }
    }
  }
`;
export const Component = function JobsHiring(props) {
    const defaultMutationReturnData = {
        id: props.data.currentAccount.id,
        hasSeenNotifications: {
            jobsCta: props.data.currentUser.hasSeenNotifications.jobsCta,
        },
    };
    const [setHasSeenJobsCta] = props.useMutation(setHasSeenJobsCtaMutation, {
        update: (cache, { data = defaultMutationReturnData }) => {
            cache.modify({
                id: cache.identify(data),
                fields: {
                    hasSeenNotifications(hasSeenNotifications = {}) {
                        return Object.assign(Object.assign({}, hasSeenNotifications), { jobsCta: data.hasSeenNotifications.jobsCta });
                    },
                },
            });
        },
    });
    const onDismiss = () => {
        setHasSeenJobsCta({
            variables: {
                profileId: props.data.currentUser.id,
                hasSeenCta: true,
            },
        });
    };
    const title = (isolateComponent("span", null,
        "We\u2019re hiring \u2014 ",
        isolateComponent(Link, { href: "/about" }, "work remotely"),
        "!"));
    return (isolateComponent(Alert, { layout: props.layout, onDismiss: onDismiss, title: title, type: "info" }));
};
//# sourceMappingURL=JobsHiring.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
